exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "iframe {\n  height: 100%;\n  width: 100%;\n  display: block;\n  border: 0px none;\n  padding: 0px;\n}\n\n.evaluation {\n  background: #fff;\n  text-align: center;\n  color: #777 !important;\n  text-transform: uppercase;\n}\n\n.evaluation > h2 {\n  font-size: 1.3em !important;\n  position: fixed;\n  background: #fff;\n  top: 0;\n  left: calc((100vw / 2) - (700px / 2));\n  width: 700px;\n  z-index: 10000;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  line-height: 48px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/scormcloud/scorm-cloud.component.css
// module id = 780
// module chunks = 0